<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__8_timeline')}}</h4>
    <p>
      {{$t('medium_grant.technical__8_timeline_sub')}}
    </p>
    <div class="row mt-5">
      <div class="col-lg-4">
        <div class="row">
          <div class="col-lg-10">
            <base-input
              type="text"
              name="technical.projectDurationMonths"
              v-model="months"
              :error="getError('technical.projectDurationMonths')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__8_project_duration_months')"
              :label="$t('medium_grant.technical__8_project_duration_months')"
              :placeholder="$t('medium_grant.technical__8_project_duration_months')"
            >
            </base-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <label> {{$t('medium_grant.technical__8_include_timeline_proposed')}} </label>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="row">
          <div class="col-lg-10">
            <base-input
              type="text"
              name="technical.projectDurationMonths"
              v-model="result"
              :error="errorEmptyResult"
              :label="$t('medium_grant.technical__8_timeline_insert_result')"
              :placeholder="$t('medium_grant.technical__8_timeline_insert_result')"
            >
            </base-input>
          </div>
          <div class="col-lg-2">
            <div>
              <label> </label>
            </div>
            <base-button
              type="primary"
              size="sm"
              @click="insertResult()"
            >
              +
            </base-button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div v-for="(result, index) in results" :key="index">
              <label><strong>{{$t('medium_grant.technical__8_timeline_result')}} {{index+1}}:</strong>
                <span class="ml-2">{{result.name}}</span></label>

              <div class="row">
                <div class="col-lg-8 offset-2">
                  <base-input
                    type="text"
                    name="technical.projectDurationMonths"
                    v-model="result.activity"
                    :error="errorEmptyActivity"
                    :label="$t('medium_grant.technical__8_timeline_insert_activity')"
                    :placeholder="$t('medium_grant.technical__8_timeline_insert_activity')"
                  >
                  </base-input>
                </div>
                <div class="col-lg-2">
                  <div>
                    <label> </label>
                  </div>
                  <base-button
                    type="primary"
                    size="sm"
                    @click="insertActivity(result)"
                  >
                    +
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div>
          <label> </label>
        </div>
        <table width="100%" class="table-bordered">
          <tr>
            <td width="15%">
              <strong>{{$t('medium_grant.technical__8_timeline_month')}}</strong>
            </td>
            <td v-for="month in projectMonths" :key="month.id">
              {{month.id}}
            </td>
          </tr>
          <template v-for="(result, resultIndex) in results">
            <tr v-for="(result, resultIndexGhost) in results" :key="'result-'+(resultIndex+resultIndexGhost)" v-if="resultIndex == resultIndexGhost">
              <td :colspan="projectMonths.length + 1">
                <a @click="results.splice(resultIndex, 1)" class="pull-right mr-2 mt-1 cursor-pointer">
                  <i class="tim-icons icon-simple-remove"></i> </a>
                <div class="row">
                  <div class="col-lg-3">
                    <label>
                      <strong>{{$t('medium_grant.technical__8_timeline_result') + ' ' + (resultIndex +1)}} </strong>
                    </label> <textarea
                    class="form-control"
                    :placeholder="$t('medium_grant.technical__8_timeline_insert_result_name')"
                    v-model="result.name"
                  >
                  </textarea>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-for="(activity, activityIndex) in result.activities" :key="'activity-'+resultIndex+'-'+activityIndex">
              <td>
                <div>
                  <strong>{{$t('medium_grant.technical__8_timeline_activity')}}</strong>
                  <a @click="result.activities.splice(activityIndex, 1)" class="pull-right mr-2 mt-1 cursor-pointer">
                    <i class="tim-icons icon-simple-remove"></i> </a>
                </div>
                <div>
                  <strong>{{resultIndex+1}}.{{activityIndex+1}}:</strong>
                </div>
                <div>
                  <textarea
                    class="form-control"
                    :placeholder="$t('medium_grant.technical__8_timeline_insert_activity')"
                    v-model="activity.name"
                  >
                  </textarea>
                </div>
              </td>
              <td @click="markActivityMonth(result.activities[activityIndex], activityMonth.id)" :class="{'marked': result.activities[activityIndex].months.indexOf(activityMonth.id) !== -1}" v-for="activityMonth in projectMonths" :key="activityMonth.id + monthsRenderIndex">
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        months: 24,
        monthsRenderIndex: 0,
        result: '',
        activity: '',
        results: [],
        errorEmptyResultText: this.$t('medium_grant.technical__8_timeline_result_required'),
        errorEmptyActivityText: this.$t('medium_grant.technical__8_timeline_activity_required'),
        errorEmptyResult: '',
        errorEmptyActivity: '',
      }
    },
    computed: {
      projectMonths() {
        var months = [];
        for (let i = 0; i < Number(this.months); i++) {
          months.push({
            id: i + 1
          })
        }
        return months;
      }
    },
    methods: {
      insertResult() {
        if (!this.result) {
          this.errorEmptyResult = this.errorEmptyResultText;
          return;
        }
        this.results.push({
          name: this.result,
          activities: []
        })
        this.result = '';
        this.errorEmptyResult = '';
      },
      markActivityMonth(activity, monthId) {
        let activityMonthIndex = activity.months.indexOf(monthId);
        if (activityMonthIndex === -1) {
          activity.months.push(monthId);
        } else {
          activity.months.splice(activityMonthIndex, 1);
        }
        this.monthsRenderIndex += 1;
      },
      insertActivity(result) {
        if (!result.activity || !result) return;

        result.activities.push({
          name: result.activity,
          months: []
        });

        result.activity = '';
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    mounted() {
      if (GrantForm.model.technical.timelineResults) {
        this.results = GrantForm.model.technical.timelineResults;
      }
      if (GrantForm.model.technical.timelineMonths) {
        this.months = GrantForm.model.technical.timelineMonths;
      }
    },
    watch: {
      results(value) {
        GrantForm.model.technical.timelineResults = value;
      },
      months(value) {
        GrantForm.model.technical.timelineMonths = value;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .marked {
    background-color: lightgray;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>